import { CircleText, QuestionDisplayMode } from '@doltech/ui/lib/figma/CircleText/CircleText';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { SingleAnswerMain } from '../../../student-do-test-questions/SingleAnswer';
import { DoTestSingleAnswerQuestionInstance } from '../../../student-do-test/model/Question/do-test-single-answer-question.store';

export interface TFNAnswerSubjectProps extends React.HTMLAttributes<HTMLDivElement> {
  data: DoTestSingleAnswerQuestionInstance;
}

const Main = styled(SingleAnswerMain)`
  padding: 0 12px;
  margin: 24px 0;

  .question-circle-text-container {
    display: block;
    > div {
      display: inline;
      &.question-circle {
        display: inline-flex;
        position: relative;
        top: -2px;
      }
      &.dash {
        height: 2px;
        display: inline-block;
      }
    }
  }
  .question-no-view-subject {
    &.question-circle {
      margin-right: 8px;
      align-items: center;
    }
    > span {
      font-weight: 500;
    }
    align-items: start;
  }
  box-shadow: unset;
  border: unset;
  pointer-events: none;
`;

export const TFNAnswerSubject = observer((props: TFNAnswerSubjectProps) => {
  const { data, ...rest } = props;
  const { question, formattedQuestionNo } = data;

  return (
    <Main className="dol-question single-answer" {...rest}>
      <CircleText
        className="question-no-wrapper"
        circleText={formattedQuestionNo}
        displayMode={QuestionDisplayMode.QUESTION_NO_VIEW_SUBJECT}
        useBlankDash
        text={question}
      />
    </Main>
  );
});
